import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import { Icon } from 'ui';
import ViewFinder from './ViewFinder';
import Dropzone from './Dropzone';

const MAX_FILE_SIZE = 50 * 1024 * 1024;

const IMAGE_TYPES = {
  CONTENT: 'content',
  ALT_CONTENT: 'alt_content',
};

// This is the metadata field the image record
// is located on of the update api response for
// the image, reveal, flipcard elements
//
// This enables AddToImageLibraryDialog to know which
// image was just uploaded
const IMAGE_METADATA_FIELDS = {
  [IMAGE_TYPES.CONTENT]: 'content_image',
  [IMAGE_TYPES.ALT_CONTENT]: 'alt_content_image',
};

// For flipcard and reveal, images can return
// in different metadata fields
const getMetadataImage = (responseMetadata, imageType) =>
  get(responseMetadata, IMAGE_METADATA_FIELDS[imageType]);

class ImageView extends Component {
  constructor(props) {
    super(props);
    this.state = { uploading: false };
  }

  handleImageChange = image => {
    if (image instanceof File && image.size > MAX_FILE_SIZE) {
      // eslint-disable-next-line no-alert
      alert(t('lessons.editor.image.upload_file_size_error'));
      return;
    }

    const { handleImageChange, imageType } = this.props;
    this.setState({ uploading: true }, () => {
      handleImageChange(image, imageType)
        .then(responseMetadata => {
          this.setState({ uploading: false });
          const metadataImage = getMetadataImage(responseMetadata, imageType);
          if (metadataImage) {
            this.props.toggleAddToImageLibrary(metadataImage);
          }
        })
        .catch(e => {
          console.error(e);
          this.setState({ uploading: false });
        });
    });
  };

  get getUploaderProps() {
    return {
      id: this.props.id,
      onUpload: this.handleImageChange,
      uploading: this.state.uploading,
    };
  }

  render() {
    const { image, className, labelClassName, label, hint } = this.props;

    return (
      <div className={className}>
        <h4 className={classNames('EditorElement-label', labelClassName)}>
          {label}
        </h4>
        <div className="EditorElement-hint">
          {hint}
          {image && (
            <button
              type="button"
              data-tooltip={t('images.delete')}
              className="EditorElement-controlButton ButtonWithTooltip ml-a"
              onClick={() => this.handleImageChange(null)}
            >
              <Icon name="delete" />
            </button>
          )}
        </div>
        <div className="EditorElement-fileHandler mt-8">
          {image ? (
            <ViewFinder {...this.getUploaderProps} image={image} />
          ) : (
            <Dropzone {...this.getUploaderProps} hideImageIcon />
          )}
        </div>
      </div>
    );
  }
}

ImageView.propTypes = {
  imageType: PropTypes.oneOf(Object.values(IMAGE_TYPES)).isRequired,
};

export default ImageView;
